export default {
  common: {
    projectList: "Project list",
    pleaseInputProjectName: "Keyword search",
    pipeline: "Pipeline",
    onhold: "Onhold",
    win: "Win",
    loss: "Loss",
    city: "City",
    amount: "Amount",
    winProbability: "Win Probability",
    registeredOn: "Registerd on",
    updatedOn: "Update on",
    thereAreNoMoreProjectsLeft: "There are no more projects left",

    drafting: "Drafting",
    ready: "Ready",
    shared: "Shared",
    negotiating: "Negotiating",
    secured: "Secured",
    lost: "Lost",
    onhold: "On-hold",

    INITIAL: "ECM report preparing",
    ECM_REPORT_PREPARED: "ECM report pending customer sharing",
    ECM_TO_CUSTOMER: "ECM report sent to customer",
    CUSTOMER_KIV_PROPOSAL: " Customer keep in view proposal",
    CUSTOMER_FUNDED: "Customer confirmed project funded",
    CUSTOMER_PROPOSAL: "Customer negotiating on proposal",
    EA_TO_CUSTOMER: "EA report sent to customer",
    CUSTOMER_ORDERS: "customer orders",
    LOST_TO_COMPETITION: "Lost to competition",
    STATUS_PROJECT: "Status reported in another project",
    IN_ACTIVE: "Project on-hold",
    getProjectInfoFailed: "Get project info failed",
    getCitylistFailed: "Get city list failed",
    cantGetProjectDetails: "Can't get project details",
    noProjectId: "No project id",
    noProjectState: "No project status",
    enterProjectName: "Enter project name",
    noActualEcmQuoted: "No actual ECM quoted",
    submitter: "Submitter",

    zone: "Zone",
    start: "Start",
    end: "End",
    clear: "Clear",
    search: "Search",

    details: "Details",
    delete: "Delete",
    cancel: "Cancel",
    report: "Report",
    ok: "Ok",
    confirm: "Confirm",

    preRetrofitReport: "Pre-retrofit report",
    postRetrofitReport: "Post-retrofit report",
    downloadProjectReport: "Download project details & reports",
    sureDelProject: "Are you sure to delete this project ?",
    projectDetail: "Project detials output",
    status: "Status",

    today: "Today",
    yesterday: "Yesterday",
    daysAgo: "days ago",
    resetLastDate: "Reset last update date",

    sure30days: "Are you sure you haven't received any updates in the past 30 days?",
    resetUpdateToToday: "Reset update date to today",
    updateOrReset: "Update / Reset",
    insufficientPermissions: "Insufficient permissions",

    projectNotFound: "Project not found",

    sendToSFDC: "Send to SFDC"
  },
  salesforce: {
    integrationStatus: "Salesforce Integration Status",
    leadNotApplicable: "Lead status is not applicable",
    leadTransferred: "Lead has been transferred to Salesforce",
    leadTransferFailed: "Lead transfer failed",
    opportunityNotApplicable: "Opportunity status is not applicable",
    opportunitySynchronized: "Opportunity has been synchronized with Salesforce",
    opportunitySyncPending: "Opportunity synchronization pending",
    opportunitySyncFailed: "Opportunity synchronization failed",
    lastSyncAttempt: "Last Data Transfer Attempt: {date}",
    lastSynced: "Last Data Transfer: {date}",
    lastAttempt: "Last Attempt: {date}",
    lastUpdate: "Last Update: {date}",
    readyForSFDC: "Ready for SFDC",
    sentToSFDC: "Sent to SFDC",
    SFDCTransferFailed: "SFDC transfer failed",
    SendToSFDCOpportunityTitle: "Salesforce → iECM Spec Builder",
    SendToSFDCOpportunityDescription: "Send opportunity to iECM for analysis. The completed analysis report is sent back to SFDC as a one-time transfer.",
    SendToSFDCLeadTitle: "iECM Spec Builder → Salesforce",
    SendToSFDCLeadDescription: "Send lead to SFDC for seller assignment. The lead enters the lead funnel for conversion to an opportunity as a one-time transfer."
  },
  projectDlg: {
    newProject: "New project",
    projectName: "Project name",
    projectState: "Project status",
    customer: "Customer",
    address: "Address",
    customerEmail: "Customer E-mail",
    auditDate: "Audit month",
    jobsiteCity: "City",
    estimatedEcmQuoted: "Estimated ECM quoted",
    exceptedOrder: "Expected order month & year",
    winProbability: "Win probability %",
    saveRetrun: "Save & return",
    saveAudit: "Save & audit",
    statusRemarks: "Project remarks",

    actualEcmQuoted: "Actual ECM quoted",
    actualOrder: "Actual order month & year",

    projectCreationMethod: "Project Creation Method",

    duplicate: "Copy Project",
    manualInput: "New Project",
    duplicateFromOtherProject: "Use an existing project as a template",
    manuallyInputToCreateProject: "Start with a blank project",

    defaultValue: "Default value",
    enterKeyDataUseDefaultValues: "Enter a small amount of key data and use default values to create a project",
    copyFrom: "Duplicate from",
    enterMoreInformation: "Enter more information",
    pleaseSelectOne: "Please select one",

    projectNameRequire: "'Project name' is Require",
    duplicateFromRequire: "'Duplicate from' is Require",
    stateIn1CantEditIn2: "The status of this project is Win, Lost, or On hold in the 1.0 system, so it does not support editing in the 2.0 system.",

    lastUpdateDate: "Last update date",

    intelligentInsightfulImpactful: "Intelligent Energy Conservation Measures",
    carriersSoftware: "iECM Spec Builder for cooling & heating plant retrofits: build a new spec or respond to one created by others.",
    intelligent: "Intelligent",
    intelligentDetails: "Build a new tender specification → proactive (opportunity shaping), or Validate and respond to existing tender requirements → reactive (RFQ/tender response).",
    insightful: "Insightful",
    insightfulDetails: "Benchmark the proposed design against defined efficiency targets, establish the control strategy, and support it with a clear performance guarantee.",
    impactful: "Impactful",
    impactfulDetails: "Deliver a customer-ready proposal and a compelling counter-offer, supported by efficiency comparisons, charts, ROI, and payback.",
    startNewAnalysis: "START RETROFIT SPEC",

    reassignProject: "Reassign project",
    advancedSearch: "Advanced Search",
    viewAuditData: "View audit data",

    customerID: "Customer ID",
    copyFromSalesforce: "Copy from Salesforce"
  },

  downloadReportDlg: {
    retrofitSolution: "Retrofit solution",
    proposal: "proposal",
    proposalUpper: "Proposal",
    autoConfig: "auto config",
    userConfig: "user config"
  },

  wizardDlg: {
    quickAssessmentMode: "Quick Assessment",
    quickAssessmentModeDetails: "Guided wizard for rapid opportunity evaluation",
    detailedAssessmentMode: "Detailed Assessment",
    detailedAssessmentModeDetails: "Full analysis for a validated customer proposal",
    title: "iECM"
  }
}



// WEBPACK FOOTER //
// ./src/locale/projectList/en.js